import http from 'hub-http/clients/apiClient';
const MULTI_CURRENCY_GET_API = 'multi-currency/v2/currencies/information';
let multiCurrencyCachedResponse = null;

// The SegmentationFilters component does not share a cache among mounted instances, so users with large workflows
// are subject to making hundreds of requests to the multi-currency endpoint. This data rarely ever changes, so as a stopgap
// while waiting for fitlers to implement a shared cache we are going to cache it manually ourselves to avoid getting paged
// for excess unhandled promise rejections.

// Filters thread: https://hubspot.slack.com/archives/CA3JB5WLT/p1695063423335949
// Execution thread: https://hubspot.slack.com/archives/C013E449G10/p1696008049314819
export const cacheMultiCurrencyRequests = () => {
  const unalteredHttpGet = http.get;
  http.get = async (...args) => {
    const url = args[0];
    if (url.includes(MULTI_CURRENCY_GET_API)) {
      if (multiCurrencyCachedResponse) {
        return multiCurrencyCachedResponse;
      }
      const response = await unalteredHttpGet(...args);
      multiCurrencyCachedResponse = response;
      return response;
    }
    return unalteredHttpGet(...args);
  };
};